<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="flex-container-space-between vertical-center-container">
          <layout-no-padding class="vertical-center-container">
            <go-back></go-back>
            <page-title :routeProps="routeProps" noIcon custom :title="`Rate - ${id}`"></page-title>
          </layout-no-padding>
        </div>
      </v-flex>

      <flex-sub-header class="my-3">Rate Details</flex-sub-header>
      <v-flex xs12>
        <v-card hover color="grey lighten-5">
          <v-card-text>
            <layout-no-padding v-if="!!row">
              <v-flex xs12 sm6 md4 lg3 v-for="(item, i) in masterFiles" :key="i" class="mb-3">
                <layout-no-padding>
                  <h2 class="grey--text text--darken-1 body-2">{{item.text}}</h2>
                </layout-no-padding>
                <div
                  class="grey--text mt-2"
                  v-if="!!row[item.value]"
                >{{row[item.value].name}}{{row[item.value].location ? `, ${row[item.value].location}` : ''}}</div>
                <div class="grey--text mt-2" v-else>-</div>
              </v-flex>
            </layout-no-padding>
          </v-card-text>
        </v-card>
      </v-flex>
      <flex-sub-header class="my-3">
        Change History
      </flex-sub-header>

      <v-flex xs12>
        <v-card hover>
          <v-data-table
            :items="audits"
            :headers="headers"
            :rows-per-page-items="pageOptions"
            :loading="loading"
            disable-initial-sort
          >
            <template slot="no-data">
              <div class="text-xs-center grey--text subheading">No audits for this rate.</div>
            </template>
            <template slot="items" slot-scope="props">
              <tr>
                <td v-for="(header, i) in headers" :key="i">
                  <div v-if="typeof props.item[header.value] === 'boolean'">
                    <span v-if="props.item[header.value]">
                      <v-icon color="green">check</v-icon>
                    </span>
                    <span v-else>
                      <v-icon color="red">close</v-icon>
                    </span>
                  </div>
                  <div
                    v-if="typeof props.item[header.value] === 'string'"
                  >{{props.item[header.value] || '-'}}</div>
                  <div
                    v-if="typeof props.item[header.value] === 'number' && header.text.includes('Price')"
                  >${{props.item[header.value].toFixed(2) || '-'}}</div>
                  <div
                    v-if="typeof props.item[header.value] === 'number' && !header.text.includes('Price')"
                  >{{props.item[header.value].toFixed(2) || '-'}} %</div>
                  <div v-if="Array.isArray(props.item[header.value])">
                    <span v-for="(change, i) in props.item[header.value]" :key="change.field">
                      <span>{{ `${change.field}: changed from` }}</span>
                      <span class="font-weight-bold">{{ ` ${formatValueString(change.from)} ` }}</span>
                      <span>to</span>
                      <span class="font-weight-bold">{{ ` ${formatValueString(change.to)}` }}</span>
                      <br v-if="i !== props.item[header.value].length" />
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RateService from '@/services/requests/rateService'
import { findChanges } from '@/modules/audits/utils'
export default {
  name: 'RateDetail',
  data() {
    return {
      id: this.$route.params.id,
      row: null,
      audits: [],
      headers: [],
      error: false,
      routeProps: this.$store.state.global.pages.rate,
      loading: false,
      masterFiles: [
        {
          text: 'Site',
          value: 'site'
        },
        {
          text: 'Tip',
          value: 'tip'
        },
        {
          text: 'Spoil',
          value: 'spoil'
        },
        {
          text: 'Vehicle Type',
          value: 'vehicleType'
        }
      ],
      pageOptions: [10, 20, 40],
      headers: []
    }
  },
  props: {
    rate: Object
  },
  methods: {
    getRate() {
      RateService.getRateById(this.$route.params.id)
        .then(result => {
          this.row = result.data.result
          this.snack({ text: 'Rate received', color: 'blue' })
        })
        .catch(err => {
          this.error = true
          this.snackError()
        })
    },
    getAudits() {
      this.loading = true
      RateService.getAuditsByRate(this.$route.params.id)
        .then(result => {
          this.loading = false
          for (const audit of result.data.result) {
            const parsedAudit = JSON.parse(audit.data)
            parsedAudit.updatedAt = audit.updatedAt
              .replace('T', ' ')
              .replace('.000Z', '')
            parsedAudit.updatedBy = audit.user.name
            this.audits.push(parsedAudit)
          }
          this.audits.push(this.buildAuditFromRate(this.row))
          const auditsWithChanges = findChanges(this.audits)
          this.audits = auditsWithChanges
          this.audits = this.audits.reverse()
          this.getHeaders()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    getHeaders() {
      this.headers.push({
        text: 'Updated At',
        value: 'updatedAt',
        type: 'text'
      })
      this.headers.push({
        text: 'Updated By',
        value: 'updatedBy',
        type: 'text'
      })
      this.headers.push({
        text: 'Changes',
        value: 'changes',
        type: 'text'
      })

      if (!this.audits.length) {
        return
      }
      const obj = this.audits[0]
      const keyArray = Object.keys(obj)
      for (const key of keyArray) {
        const headerObj = {}
        const strArray = key.split(/(?=[A-Z])/)
        strArray[0] = this._.startCase(strArray[0])
        var string = strArray.join(' ')
        headerObj.text = string
        headerObj.value = key
        headerObj.sortable = false
        this.headers.push(headerObj)
      }
      this.headers = this.headers.slice(0, 23)
    },
    formatValueString(string) {
      switch (string) {
        case '':
          return '" "'
        case undefined:
          return 'not set'
        default:
          return string
      }
    },
    buildAuditFromRate(rate) {
      return {
        active: rate.active,
        adminFeePercentage: rate.adminFeePercentage,
        adminFeeRequired: rate.adminFeeRequired,
        costPrice: rate.costPrice,
        costPriceAlt: rate.costPriceAlt,
        costPriceAltSunday: rate.costPriceAltSunday,
        costPriceNight: rate.costPriceNight,
        costPriceSunday: rate.costPriceSunday,
        costUnit: rate.costUnit,
        costUnitAlt: rate.costUnitAlt,
        costUnitNight: rate.costUnitNight,
        costUnitSunday: rate.costUnitSunday,
        notes: rate.notes,
        sellPrice: rate.sellPrice,
        sellPriceNight: rate.sellPriceNight,
        sellPriceSunday: rate.sellPriceSunday,
        vehicleTypes: rate.rateVehicleTypes,
        updatedAt: rate.updatedAt.replace('T', ' ').replace('.000Z', ''),
        updatedBy: rate.user.name,
        useTonnage: rate.useTonnage
      }
    }
  },
  async mounted() {
    await this.getRate();
    this.getAudits();
  }
}
</script>

<style>
</style>
